import React from "react";
import { RecoilRoot } from "recoil";

import { HospitalEdit } from '../uiParts/hospital/HospitalEdit';

import { hospitalState } from '../store/hospitalState';
import { hospitalInsuranceState } from '../store/hospitalInsuranceState';
import { availableState } from '../store/availableState';
import { unavailableState } from '../store/unavailableState';
import { postState } from '../store/postState';

const Hospital = (props) => {
  const { hospital, insurances, hospital_insurances, corporations, availables, unavailables, posts, staff_user } = props;

  // 編集の場合の初期値のセット
  const initializeState = ({ set }) => {
    set(hospitalState, hospital);
    set(hospitalInsuranceState, hospital_insurances);
    set(availableState, availables);
    set(unavailableState, unavailables);
    set(postState, posts);
  };

  return (
    <RecoilRoot initializeState={initializeState}>
      <HospitalEdit init_hospital={hospital} insurances={insurances} corporations={corporations} staff_user={staff_user} />
    </RecoilRoot>
  );
};

export default Hospital;
